import { render, staticRenderFns } from "./SalesContinents.vue?vue&type=template&id=e46f38ba&"
import script from "./SalesContinents.vue?vue&type=script&lang=js&"
export * from "./SalesContinents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports